import { useState, useEffect } from 'react';

const SIDEBAR_STORAGE_KEY = 'radar-sidebar-collapsed';

export function useSidebarState(
    storageKey: string = SIDEBAR_STORAGE_KEY,
    defaultCollapsed: boolean = true
) {
  const [isCollapsed, setIsCollapsed] = useState<boolean>(() => {
    try {
      const stored = localStorage.getItem(storageKey);
      return stored ? JSON.parse(stored) : defaultCollapsed;
    } catch {
      return defaultCollapsed;
    }
  });

  useEffect(() => {
    try {
      localStorage.setItem(storageKey, JSON.stringify(isCollapsed));
    } catch (error) {
      console.warn('Failed to save sidebar state to localStorage:', error);
    }
  }, [isCollapsed, storageKey]);

  const toggleSidebar = () => {
    setIsCollapsed(prev => !prev);
  };

  return {
    isCollapsed,
    toggleSidebar,
    setIsCollapsed,
  };
}